import React from 'react'
export const RightContent = ({ url, alt = 'hero right content' }) => {
  return (
    <div className="col-md-5 col-sm-12 animate__animated animate__fadeIn d-none d-md-block ">
      <img src={`/assets/img/slide/${url}`} alt={alt} />
    </div>
  )
}
